// ActivityHistoryCard/hooks/useAdaptiveActions.tsx
import { useResponsive } from '@europrocurement/l2d-hooks';
import { NamedIconsType } from '@europrocurement/l2d-icons';

export type ActionConfig = {
    id: string;
    label: string;
    shortLabel?: string;
    icon?: NamedIconsType;
    onClick: () => void;
    variant?: 'text' | 'outlined' | 'contained';
    color?: string;
    size?: 'small' | 'medium' | 'large';
};

export type AdaptiveConfig = {
    layout: 'horizontal' | 'vertical';
    showLabels: boolean;
    buttonSize: 'small' | 'medium';
};

/**
 * Hook pour adapter les actions selon la taille d'écran.
 * Gère l'affichage des labels et la disposition des boutons.
 */
export const useAdaptiveActions = (actions: ActionConfig[]) => {
    const { isMobile, isTablet, getResponsiveValue } = useResponsive();

    const config: AdaptiveConfig = getResponsiveValue({
        mobile: {
            layout: 'vertical' as const,
            showLabels: false,
            buttonSize: 'small' as const,
        },
        tablet: {
            layout: 'horizontal' as const,
            showLabels: true,
            buttonSize: 'small' as const,
        },
        desktop: {
            layout: 'horizontal' as const,
            showLabels: true,
            buttonSize: 'small' as const,
        },
    });

    const adaptedActions = actions.map((action) => {
        let displayLabel = '';

        if (config.showLabels) {
            if (isMobile && action.shortLabel) {
                displayLabel = action.shortLabel;
            } else {
                displayLabel = action.label;
            }
        }

        return {
            ...action,
            displayLabel,
            size: action.size || config.buttonSize,
        };
    });

    return {
        config,
        adaptedActions,
        isMobile,
        isTablet,
    };
};
